import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import { InventoryComponent } from './inventory.component';
import { ProductListComponent } from './product-list';
import { InventoryDetailComponent } from './inventory-detail';
import { ProductTransferComponent } from './product-transfer';
import { ProductsTransferComponent } from './products-transfer';
import { TransferLocationsComponent } from './transfer-locations';
import { TransferHistoryComponent } from './transfer-history';

const inventoryRoutes: Routes = [
    {
        path: 'inventory',
        component: InventoryComponent,
        children: [
            {
                path: '',
                component: ProductListComponent
            },
            {
                path: 'inventory-detail/:id',
                component: InventoryDetailComponent
            },
            {
                path: 'trasfer-product/:productId/:locationTo/:locationFrom',
                component: ProductTransferComponent
            },
            {
                path: 'trasfer-products/:locationTo/:locationFrom',
                component: ProductsTransferComponent
            },
            {
                path: 'transfer',
                component: TransferLocationsComponent
            },
            {
                path: 'transfer-history',
                component: TransferHistoryComponent
            }
        ]
    }

];

export const inventoryRouting: ModuleWithProviders = RouterModule.forChild(inventoryRoutes);


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/inventory.routing.ts